export const LANGUAGES_LABEL_MAP: { [lang: string]: string } = {
  en: 'English',
  es: 'Español',
  zh: '中文',
  hi: 'हिन्दी',
  ar: 'العربية',
  pt: 'Português',
  bn: 'বাঙালি',
  ru: 'Русский',
  ja: '日本語',
  de: 'Deutsch',
  fr: 'Français',
  ko: '한국어',
  it: 'Italiano',
  tr: 'Türkçe',
  nl: 'Nederlands',
  pl: 'Polski',
  vi: 'Tiếng Việt',
  sv: 'Svenska',
  uk: 'Українська',
  ro: 'Română',
  fa: 'فارسی',
  th: 'ไทย',
  el: 'Ελληνικά',
  cs: 'Čeština',
  he: 'עברית',
  id: 'Bahasa Indonesia',
  da: 'Dansk',
  no: 'Norsk',
  fi: 'Suomi',
  hu: 'Magyar',
  sk: 'Slovenčina',
  bg: 'Български',
  sr: 'Српски'
}

const COMMON = ['es', 'en', 'fr', 'it', 'pt']

export const COMMON_LANGUAGES: { value: string; label: string }[] =
  Object.entries(LANGUAGES_LABEL_MAP)
    .filter(([value]) => COMMON.includes(value))
    .map(([value, label]) => ({
      value,
      label
    }))

export const LANGUAGES: { value: string; label: string }[] = Object.entries(
  LANGUAGES_LABEL_MAP
)
  .filter(([value]) => !COMMON.includes(value))
  .map(([value, label]) => ({ value, label }))
